import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const FeedAuditListPage = lazy(() => import('~/features/feed-audit/pages/feed-audit-list-page'));

export const Route = createFileRoute('/_authenticated/_tenant/feed-audit/')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <FeedAuditListPage />
    </Suspense>
  ),
});
